import {localPoint} from '@visx/event';
import clsx from 'clsx';

import {getTextColour} from '../utils/functions';

import type {PieBarDatum, TooltipParams} from '../utils/types';

type PieRenderProps<T> = Parameters<
  // @ts-expect-error it's working
  Parameters<typeof Pie<T>>[0]['children']
>[0];

type Props<T extends PieBarDatum> = {
  pie: PieRenderProps<T>;
  idx: number;
  pieArcDatum: PieRenderProps<T>['arcs'][number];
  pieChartDatum: T;
  tooltipHelpers: TooltipParams<T>;
  handleDatumClick?: (item: T) => void;
};
export function PieArc<T extends PieBarDatum>({
  pie,
  idx,
  pieArcDatum,
  pieChartDatum,
  handleDatumClick,
  tooltipHelpers,
}: Props<T>): React.JSX.Element | null {
  const arcPath = pie.path(pieArcDatum);
  const arcId = pieArcDatum.data.id;
  const hasSpaceForLabel = pieArcDatum.endAngle - pieArcDatum.startAngle >= 0.2;
  const [centroidX, centroidY] = pie.path.centroid(pieArcDatum);
  const {showTooltip, hideTooltip} = tooltipHelpers;

  if (!arcPath) return null;

  return (
    <>
      <path
        key={arcId}
        d={arcPath}
        fill={pieChartDatum.fill}
        onClick={() => handleDatumClick?.(arcId)}
        onMouseLeave={hideTooltip}
        onMouseMove={(event) => {
          const eventSvgCoords = localPoint(event);
          showTooltip({
            tooltipData: pieChartDatum,
            tooltipTop: eventSvgCoords?.y,
            tooltipLeft: eventSvgCoords?.x,
          });
        }}
      />

      {hasSpaceForLabel && (
        <text
          x={centroidX}
          y={centroidY}
          style={{textAnchor: 'middle'}}
          className={clsx(
            'pointer-events-none text-sm font-semibold',
            `fill-${getTextColour(pieChartDatum.fill)}`
          )}
        >
          #{idx}
        </text>
        // <>
        //   <text
        //     x={centroidX}
        //     y={centroidY}
        //     style={{textAnchor: 'middle'}}
        //     className={clsx(
        //       'pointer-events-none text-sm font-semibold',
        //       `fill-${getTextColour(pieChartDatum.fill)}`
        //     )}
        //   >
        //     {truncate(pieChartDatum.name, 12)}
        //   </text>
        //   <text
        //     x={centroidX}
        //     y={centroidY}
        //     dy="1.25em"
        //     style={{textAnchor: 'middle'}}
        //     className={clsx(
        //       'pointer-events-none text-xs font-semibold',
        //       `fill-${getTextColour(pieChartDatum.fill)}`
        //     )}
        //   >
        //     ({pieChartDatum.percent}%)
        //   </text>
        // </>
      )}
    </>
  );
}

PieArc.displayName = 'PieArc';
